import { FC } from "react";

type Props = {
  width?: number | string;
  height?: number | string;
  className?: string;
};

const ExcelIcon: FC<Props> = ({ width = 18, height = 18, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect width="32" height="32" rx="5" fill="#107C41" />
    <path
      d="M18.8 8H24.5C25.3 8 26 8.7 26 9.5V22.5C26 23.3 25.3 24 24.5 24H18.8V8Z"
      fill="#21A366"
    />
    <path d="M18.8 8H13.2V13.5H18.8V8Z" fill="#107C41" />
    <path d="M18.8 13.5H13.2V18.5H18.8V13.5Z" fill="#185C37" />
    <path d="M18.8 18.5H13.2V24H18.8V18.5Z" fill="#107C41" />
    <path
      d="M6 10.5C6 9.7 6.7 9 7.5 9H15.5C16.3 9 17 9.7 17 10.5V21.5C17 22.3 16.3 23 15.5 23H7.5C6.7 23 6 22.3 6 21.5V10.5Z"
      fill="#107C41"
    />
    <path
      d="M9.2 13L10.7 15.8L12.3 13H14.1L11.7 16.2L14.2 19.5H12.3L10.7 16.7L9.2 19.5H7.3L9.8 16.2L7.4 13H9.2Z"
      fill="#FFFFFF"
    />
  </svg>
);

export default ExcelIcon;
